import { CrudResult } from "../../redux/types";

export const validationHelper = (
  crudResult: CrudResult,
  processField: (name: string, message: string) => void
) => {
  if (crudResult.isSuccess === false) {
    const { errors } = crudResult.errorState;
    Object.keys(errors).forEach((name) =>
      errors[name].forEach((message) => processField(name, message))
    );
  }
};
